import { set } from "date-fns";
import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import "./CurrentStageFilter.scss";

const CurrentStageFilter = ({
  onRetrieveCurrentStageData,
  value,
  setCurrentStage,
}) => {

  const handleCheckBoxChange = (e) => {
    if (e.target.checked) {
      const data = {
        label: "Current Stage",
        value: e.target.checked,
        externalFilter: "true",
      };
      onRetrieveCurrentStageData(data);
      setCurrentStage(data);
    } else {
      const data = {
        label: "Current Stage",
        value: null,
        externalFilter: true,
      };
      onRetrieveCurrentStageData(data);
      setCurrentStage(data);
    }
  };

  return (
    <FormGroup check>
      <Label check className="current-stg-label">
        <Input
          checked={value || false}
          type="checkbox"
          onChange={handleCheckBoxChange}
        />
        Show Current Stages
      </Label>
    </FormGroup>
  );
};

export default CurrentStageFilter;
